import ArticleSelect from 'flaivy-react/components/selects/ArticleSelect';
import SupplierSelect from './inputs/SupplierSelect';
import LabelSelect from 'flaivy-react/components/selects/LabelSelect';
import BrandSelect from './inputs/generated/BrandSelect';
import OrderSelect from './inputs/generated/OrderSelect';
import UserSelect from './inputs/generated/UserSelect';
import OrganizationSelect from './inputs/generated/OrganizationSelect';
import ShopUserSelect from './inputs/generated/ShopUserSelect';
import PurchaseOrderSelect from './inputs/generated/PurchaseOrderSelect';
import CustomerSubUnitSelect from './inputs/generated/CustomerSubUnitSelect';
import PriceListSelect from './inputs/generated/PriceListSelect';
import InvoiceSelect from './inputs/generated/InvoiceSelect';
import IntegrationSelect from './inputs/generated/IntegrationSelect';
import EndCustomerInInventorySelect from './inputs/generated/CustomerSubUnitSelect'; // going with the same select as CustomerSubUnitSelect here
import SupplierCustomerSelect from './inputs/SupplierCustomerSelect';
import SupplierCustomerInOmsServiceSelect from './inputs/generated/SupplierCustomerInOmsServiceSelect';
import ShopConfigSelect from './inputs/generated/ShopConfigSelect';
import EndCustomerOrganizationSelect from './inputs/generated/EndCustomerOrganizationSelect';
import ProcurementArticleSelect from './inputs/generated/ProcurementArticleSelect';
import ProcurementListSelect from './inputs/generated/ProcurementListSelect';
import ArticleInInventorySelect from 'flaivy-react/components/selects/ArticleSelect'; // going with the same select as article here
import CustomerSubUnitInPcsServiceSelect from './inputs/generated/CustomerSubUnitSelect';
import SupplierCustomerInPcsServiceSelect from './inputs/generated/SupplierCustomerInPcsServiceSelect';
import SupplierInPcsServiceSelect from './inputs/generated/SupplierSelect';
import OrderFullfillmentCenterSelect from './inputs/OrderFullfillmentCenterSelect';
import OfcInSupplierGatewaySelect from './inputs/generated/OrderFullfillmentCenterSelect';
import OfcInCrmSelect from './inputs/generated/OrderFullfillmentCenterSelect';
import OrganizationInPcsServiceSelect from './inputs/generated/OrganizationInPcsServiceSelect';
import OrganizationInOmsServiceSelect from './inputs/generated/OrganizationInOmsServiceSelect';
import OrderBrokerageAgreementSelect from './inputs/generated/OrderBrokerageAgreementSelect';
import CopackAgreementSelect from './inputs/generated/CopackAgreementSelect';
import SettlementSelect from './inputs/generated/SettlementSelect';
import MappingTemplateSelect from './inputs/generated/MappingTemplateSelect';
import CampaignSelect from './inputs/generated/CampaignSelect';
import FailedActionCallSelect from './inputs/generated/FailedActionCallSelect';
import IncomingMessageSelect from './inputs/generated/IncomingMessageSelect';
const PricedArticleSelect = ArticleSelect;
export {
  SupplierSelect,
  BrandSelect,
  OrderSelect,
  UserSelect,
  OrganizationSelect,
  ShopUserSelect,
  PurchaseOrderSelect,
  CustomerSubUnitSelect,
  ArticleSelect,
  PricedArticleSelect,
  PriceListSelect,
  InvoiceSelect,
  IntegrationSelect,
  EndCustomerInInventorySelect,
  SupplierCustomerSelect,
  ShopConfigSelect,
  SupplierCustomerInOmsServiceSelect,
  EndCustomerOrganizationSelect,
  ProcurementArticleSelect,
  ProcurementListSelect,
  ArticleInInventorySelect,
  CustomerSubUnitInPcsServiceSelect,
  OrderFullfillmentCenterSelect,
  SupplierInPcsServiceSelect,
  SupplierCustomerInPcsServiceSelect,
  OfcInSupplierGatewaySelect,
  OfcInCrmSelect,
  OrganizationInPcsServiceSelect,
  OrganizationInOmsServiceSelect,
  LabelSelect,
  OrderBrokerageAgreementSelect,
  CopackAgreementSelect,
  SettlementSelect,
  MappingTemplateSelect,
  CampaignSelect,
  FailedActionCallSelect,
  IncomingMessageSelect,
};
